import React from 'react'

export const countryFlags = [
    'CA',
    'HK',
    'IS',
    'PH',
    'DK',
    'HU',
    'CZ',
    'GB',
    'RO',
    'SE',
    'ID',
    'IN',
    'BR',
    'RU',
    'CR',
    'JP',
    'TH',
    'CH',
    'EU',
    'MY',
    'BG',
    'TR',
    'CN',
    'NO',
    'NZ',
    'ZA',
    'US',
    'MX',
    'SG',
    'AU',
    'IL',
    'KR',
    'PL',
]

export const countryNames = [
    'Canada',
    'Hong Kong',
    'Iceland',
    'Philippines',
    'Denmark',
    'Hungary',
    'Czechia',
    'Great Britain',
    'Romania',
    'Sweden',
    'Indonesia',
    'India',
    'Brazil',
    'Russia',
    'Croatia',
    'Japan',
    'Thailand',
    'Switzerland',
    'EU',
    'Malaysia',
    'Bulgaria',
    'Turkey',
    'China',
    'Norway',
    'New Zealand',
    'South Africa',
    'US',
    'Mexico',
    'Singapore',
    'Australia',
    'Israel',
    'Korea',
    'Poland',
]

export const currencyNames = [
    'AUD',
    'BGN',
    'BRL',
    'CAD',
    'CHF',
    'CNY',
    'CZK',
    'DKK',
    'EUR',
    'GBP',
    'HKD',
    'HRK',
    'HUF',
    'IDR',
    'ILS',
    'INR',
    'ISK',
    'JPY',
    'KRW', 
    'MXN',
    'MYR',
    'NOK',
    'NZD',
    'PHP',
    'PLN',
    'RON',
    'RUB',
    'SEK',
    'SGD',
    'THB',
    'TRY',
    'USD',
    'ZAR'
]